import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H5 } from 'UIComponents/elements/headings';
import UILink from 'UIComponents/link/UILink';
import SocialLink from '../../../components/SocialLink';
import { hubspotEditPagePaths } from '../../../utils/urls';
import { useIsCurrentUser, useUserByUsername } from '../userQueries';

const UserSocials = ({
  username
}) => {
  const {
    user
  } = useUserByUsername(username);
  const ownProfile = useIsCurrentUser(user ? user.userId : undefined);
  const userHasSocials = user && Boolean(user.linkedinId || user.twitterId || user.githubId || user.meetingsId);
  if (!userHasSocials) return null;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(H5, {
        style: {
          display: 'inline-block',
          marginRight: 8
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "connectDotCom.profile.connect"
        })
      }), ownProfile && /*#__PURE__*/_jsx(UILink, {
        href: hubspotEditPagePaths.edit(),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "connectDotCom.edit"
        })
      })]
    }), /*#__PURE__*/_jsx(SocialLink, {
      socialMediaName: "linkedin",
      socialMediaId: user.linkedinId
    }), /*#__PURE__*/_jsx(SocialLink, {
      socialMediaName: "twitter",
      socialMediaId: user.twitterId
    }), /*#__PURE__*/_jsx(SocialLink, {
      socialMediaName: "github",
      socialMediaId: user.githubId
    }), /*#__PURE__*/_jsx(SocialLink, {
      socialMediaName: "meetings",
      socialMediaId: user.meetingsId
    })]
  });
};

export default UserSocials;